import { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import ConnexionLayout from "../../components/ConnexionLayout";
import TextInput from "../../components/TextInput";
import Button from "../../components/Button";
import { verifyInvite } from "../../services/api/invite";
import { getTokenPayload } from "../../utils/jwt";
import { postUser } from "../../types/api/user";
import { createUser } from "../../services/api/user";

import "./style.css";

const Register: FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const query = new URLSearchParams(location.search);
    const token = query.get("token");
    const emailToken = getTokenPayload(token!).email;

    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState(emailToken || "");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isTokenValid, setIsTokenValid] = useState<boolean | null>(null);

    // TODO: Gérer les erreurs global
    // const [error, setError] = useState<string | null>(null);
    const [fieldErrors, setFieldErrors] = useState<{ [key: string]: string }>(
        {}
    );
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false); // Nouveau state pour afficher le contenu de succès

    useEffect(() => {
        if (token) {
            verifyInvite(token)
                .then((isOk) => {
                    if (isOk) {
                        setIsTokenValid(true);
                    } else {
                        throw new Error("Token invalide.");
                    }
                })
                .catch(() => {
                    setIsTokenValid(false);
                    navigate("/login");
                    // setErrorMessage("Le token a expiré ou est invalide.");
                });
        } else {
            navigate("/login");
        }
    }, [token, navigate]);

    const handleRegister = async () => {
        setLoading(true);
        // setError(null);
        setFieldErrors({}); // Réinitialiser les erreurs des champs

        try {
            // Appel au service d'inscription
            let userInput: postUser = {
                token: token!,
                firstname,
                lastname,
                password: newPassword,
                confirmPassword
            };

            if (!emailToken) {
                userInput.email = email;
            }

            await createUser(userInput);

            // Passer en mode succès
            setSuccess(true);
        } catch (err: any) {
            if (err.response && err.response.data) {
                // Gérer les erreurs spécifiques aux champs
                if (err.response.data.errors) {
                    const errors = err.response.data.errors.reduce(
                        (acc: any, curr: any) => {
                            acc[curr.field] = curr.message; // Associer chaque erreur au champ concerné
                            return acc;
                        },
                        {}
                    );
                    setFieldErrors(errors);
                } else {
                    // Gérer les erreurs globales
                    // setError(
                    //     err.response.data.message || "Une erreur est survenue."
                    // );
                }
            } else {
                // setError("Impossible de se connecter au serveur.");
            }
        } finally {
            setLoading(false);
        }
    };


    if (isTokenValid === null) {
        return <></>; // Loader pendant la vérification
    }

    return (
        <ConnexionLayout>
            {success ? (
                <>
                    <p className="connexion_card_title">
                        Inscription réussie !
                    </p>
                    <p className="connexion_card_subtitle">
                        Ton compte a été créé avec succès. Tu peux maintenant te
                        connecter.
                    </p>
                    <Button
                        label="Aller à la page de connexion"
                        onClick={() =>
                            navigate("/login", {
                                state: { email: getTokenPayload(token!).email },
                            })
                        }
                    />
                </>
            ) : (
                <>
                    <p className="connexion_card_title">Bienvenue !</p>
                    <p className="connexion_card_subtitle">
                        Inscris-toi pour accéder au site.
                    </p>
                    <div className="register_form_inputs">
                        <TextInput
                            value={firstname}
                            setValue={setFirstname}
                            label="Prénom"
                            placeholder="Ton prénom"
                            error={fieldErrors.firstname}
                        />
                        <TextInput
                            value={lastname}
                            setValue={setLastname}
                            label="Nom"
                            placeholder="Ton nom"
                            error={fieldErrors.lastname}
                        />
                        <TextInput
                            value={email}
                            setValue={setEmail}
                            label="Email"
                            placeholder="Ton adresse e-mail"
                            disabled={emailToken !== undefined}
                            error={fieldErrors.email}
                        />
                        <TextInput
                            id="new-password"
                            value={newPassword}
                            setValue={setNewPassword}
                            label="Mot de passe"
                            placeholder="Mot de passe"
                            type="password"
                            error={fieldErrors.password}
                        />
                        <TextInput
                            id="confirm-password"
                            value={confirmPassword}
                            setValue={setConfirmPassword}
                            label="Confirmer le mot de passe"
                            placeholder="Confirmer ton mot de passe"
                            type="password"
                            error={fieldErrors.confirmPassword}
                        />
                    </div>

                    {loading ? (
                        <CircularProgress
                            className="register_loader"
                            size={45}
                        />
                    ) : (
                        <Button label={"S'inscrire"} onClick={handleRegister} />
                    )}
                </>
            )}
        </ConnexionLayout>
    );
};

export default Register;
